import React, { createContext, useState, useContext, useCallback } from 'react';
import { Alert } from 'react-bootstrap';

const NotificationContext = createContext(null);

export const useNotification = () => {
  return useContext(NotificationContext);
};

const NotificationComponent = ({ message, variant, onClose }) => {
  // Disparaît automatiquement après 5 secondes
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div style={{ position: 'fixed', top: '80px', right: '20px', zIndex: 1050, minWidth: '300px' }}>
      <Alert variant={variant} onClose={onClose} dismissible>
        {message}
      </Alert>
    </div>
  );
};

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = useCallback((message, variant = 'info') => {
    setNotification({ message, variant });
  }, []);

  const closeNotification = useCallback(() => {
    setNotification(null);
  }, []);

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      {notification && (
        <NotificationComponent
          message={notification.message}
          variant={notification.variant}
          onClose={closeNotification}
        />
      )}
    </NotificationContext.Provider>
  );
};
